import { InviteInterface } from "../../project/interfaces";
import { useApiCall } from "../../../hooks/useApiCall";
import ProjectsApi from "../../project/api";
import Grid from "@mui/material/Grid2";
import UserPreview from "../../../components/UsersPreview/UserPreview";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";
import { Button } from "@mui/material";
import ErrorSnackbar from "../../../components/snackbars/ErrorSnackbar";
import i18nStore from "../../../i18n/store";


export interface SentInviteInterface {
    invite: InviteInterface;
    onRevokeInvite: () => void;
}

const OutcomeInvite = (props: SentInviteInterface) => {
    const translations = i18nStore.getTranslations;
    const cancelInviteApi = useApiCall(
        () => ProjectsApi.cancelInvite(props.invite.id).then(() => {
            props.onRevokeInvite();
        }),
        null,
    );

    return (
        <>
            <Grid container spacing={2}>
                <Grid size={{ xs: 7, lg: 3 }}>
                    <UserPreview user={{id: props.invite.guest_id, name: props.invite.guest_name}} />
                </Grid>
                <Grid size={{ xs: 3, lg: 2 }}>
                    <Typography variant="caption">{dayjs(props.invite.created_at).format('YYYY-MM-DD HH:mm:ss')}</Typography>
                </Grid>

                <Grid size={{ xs: 2, lg: 1 }}>
                    <Button variant="contained" color="error" onClick={() => cancelInviteApi.apiCaller()}>
                        {translations._invites.cancel}
                    </Button>
                </Grid>
            </Grid>
            <ErrorSnackbar handleClose={cancelInviteApi.resetApiCallStatus} isOpen={cancelInviteApi.error}>
                {translations._invites.errorCancelInvites}
            </ErrorSnackbar>
        </>

    );
};


export default OutcomeInvite;
